module.exports = __webpack_public_path__ + "static/media/599.767(15).cb6efb7b.pdf";